module.exports = __webpack_public_path__ + "static/media/engine-green.21d35e0e.svg";